import React, { useEffect } from 'react';

function AlcoholCommonTable({
	type,
	tableHeader,
	tableBody,
	checkedItems=[],
	setCheckedItems=null,
	totalCheck,
	setTotalCheck,
	setShowModifyModal=null,
	setModifyTarget=null,
	authorityData=[],
	setAuthorityData=null,
	modifyAuthorityList={},
	setModifyAuthorityList=null,
	clickEvent=null
}) {

	function selectAllItems(e) {
		const newSelectedItems = {};
		if (e.target.checked === true) {
			tableBody.forEach((item, idx) => {
				newSelectedItems[idx] = item;
			});
		}
		setCheckedItems(newSelectedItems);
		setTotalCheck(!totalCheck);
	}

	function selectEachItem(e, item, idx) {
		const newSelectedItems = { ...checkedItems };
		if (e.target.checked === false) {
			delete newSelectedItems[idx];
			setTotalCheck(false);
		} else {
			newSelectedItems[idx] = item;
		}
		setCheckedItems(newSelectedItems);
	}

	function handleChangeCheck(item, headerItem, e) {
		const targetId = item.ID;
		const targetIdx = authorityData.findIndex(el=>el.ID===targetId);
		console.log('targetIdx',targetIdx)
		const targetItem = authorityData[targetIdx];
		const modifyList = [
			...authorityData.slice(0,targetIdx),
			{
				...targetItem,
				[headerItem]: e.target.checked
			},
			...authorityData.slice(targetIdx+1)
		];
		setAuthorityData(modifyList);

		setModifyAuthorityList({
			...modifyAuthorityList,
			[targetId]: modifyList[targetIdx]
		})
	}

	useEffect(()=>{
		if(type==="notification"){
			const textDOMList = document.querySelectorAll('.hide_long_text');
			
			textDOMList.forEach(e=>{
				if(e.scrollWidth>e.clientWidth){
					e.classList.add('overflow');
				}else{
					e.classList.remove('overflow');
				}
			})
		}	
	},[type, tableBody])

	return (
		<table className={`AlcoholCommonTable ${type==='login_history' ? 'width-auto': ''}`}>
			<thead>
				<tr>
					{type!=="authority" && type!=="login_history" && type!=="notification" && <th className='Checkbox-Item'>
						<input
							type="checkbox"
							onChange={(e)=>selectAllItems(e)}
							checked={totalCheck}
							aria-label='Table All Checkbox'
						/>
					</th>}
					{tableHeader.map(item => {
						return <th key={item}>{item}</th>;
					})}
				</tr>
			</thead>
			<tbody>
				{tableBody.map((item, idx) => {
					return (
						<tr key={item["번호"] || item.ID || idx}>
							{type!=="authority" && type!=="login_history" && type!=="notification" && <td className='Checkbox-Item'>
								<input
									type="checkbox"
									onChange={(e)=>selectEachItem(e, item, idx)}
									checked={idx in checkedItems}
									aria-label='Table Item Checkbox'
								/>
							</td>}
							{tableHeader.map(headerItem => {
								return (
									<td
										key={headerItem}
										className={`${headerItem} ${type==="notification" && headerItem==="내용" ? 'hide_long_text' : ""}`}
										style={{ cursor: `${(type==="patient" || type==="notification") ? "pointer" : "default"}`}}
										onClick={()=>(type==="patient" || type==="notification") && clickEvent(item)}
									>
										{(type!=="authority" || headerItem==="ID" || headerItem==="메뉴명") ? item[headerItem] : (
											<input
												type="checkbox"
												checked={item[headerItem]}
												onChange={(e)=>handleChangeCheck(item, headerItem, e)}
												aria-label='Table Authority Checkbox'
											/>
										)}
									</td>
								);
							})}
							{type!=="patient" && type!=="authority" && type!=="login_history" && type!=="notification" && <td className='Table-Modify'>
								<button
									onClick={()=>{
										setModifyTarget(item.ID ? item.ID : item.번호);
										setShowModifyModal(true);
									}}
								>수정</button>
							</td>}
						</tr>
					);
				})}
			</tbody>
		</table>
	);
}

export default AlcoholCommonTable;
